module.exports = __webpack_public_path__ + "static/img/zf_img_bg01.2cfa5f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_bg01.png
// module id = ap15
// module chunks = 1